<template>
  <div class="nav">
    <div class="nav_con">
      <router-link to="/home" class="nav_logo">
        <img src="../../assets/images/logo1.png" alt="" />
      </router-link>
      <ul class="menu">
        <li
          @click="
            goNavHandle({
              path: '/product/cart',
            })
          "
        >
          <div class="icon_cart"></div>
          <span>购物车</span>
        </li>
        <li
          @click="
            goNavHandle({
              path: '/mine/order',
            })
          "
        >
          <div class="icon_user">
            <img
              :src="
                userInfo
                  ? userInfo.avatar
                  : require('../../assets/images/icon1.png')
              "
              alt=""
              srcset=""
            />
          </div>
          <span>{{ userInfo ? "会员中心" : "未登录" }}</span>
        </li>
        <!-- <li
          @click="
            goNavHandle({
              path: '/product/centerOne',
            })
          "
        >
          产品中心
        </li> -->
        <li class="on">
          打开小程序
          <div class="sub">
            <img src="../../assets/images/qr.png" alt="" srcset="" />
          </div>
        </li>
        <li>联系客户</li>
      </ul>
      <div class="sreach">
        <input
          type="text"
          placeholder="您的搜索从这里开始"
          v-model="serachContent"
          @keyup.enter="serach"
        />
        <div class="icon_sreach" @click="serach"></div>
      </div>
    </div>
  </div>
</template>
<script>
import { ref } from 'vue'
import { useStore } from 'vuex'
import { useRouter } from 'vue-router'
export default {
  setup () {
    const store = useStore()
    const router = useRouter()
    const serachContent = ref('') // 搜索内容
    const userInfo = store.state.userInfo
    const goNavHandle = (obj) => {
      router.push(obj)
    }
    const serach = () => {
      store.state.serachContent = serachContent.value
      router.push({ path: '/search/index' })
    }
    return {
      serachContent,
      serach,
      goNavHandle,
      userInfo
    }
  }
}
</script>
<style lang="scss" scoped>
.nav {
  width: 100%;
  height: 70px;
  background: #2e2828;
  display: flex;
  justify-content: center;
  align-items: center;
  .sreach {
    width: 286px;
    height: 32px;
    background: rgba(255, 255, 255, 0.6);
    display: flex;
    justify-content: space-between;
    align-items: center;
    border-radius: 18px;
    box-sizing: border-box;
    padding: 0 16px;
    input {
      color: rgba(255, 254, 254, 0.6);
      background: none;
      border: none;
      outline: none;
      padding: 0;
    }
    input::placeholder {
      color: rgba(255, 254, 254, 0.6);
    }
    .icon_sreach {
      width: 16px;
      height: 16px;
      background-image: url(../../assets/images/icon3.png);
      cursor: pointer;
    }
  }
  .nav_con {
    width: 1200px;
    display: flex;
    justify-content: space-between;
    align-items: center;
    .menu {
      display: flex;
      flex: 1;
      margin: 0 0 0 30px;
      li {
        display: flex;
        align-items: center;
        font-size: 18px;
        color: #ffffff;
        opacity: 0.6;
        padding: 0 16px 0 0;
        margin: 0 0 0 16px;
        border-right: 1px solid #414141;
        cursor: pointer;
        position: relative;
        &:last-child {
          border: none;
        }
        &:hover {
          opacity: 1;
        }
        &.on > .sub {
          width: 260px;
          height: 260px;
          position: absolute;
          top: 28px;
          left: -76px;
          display: none;
          z-index: 100;
        }
        &.on:hover > .sub {
          display: block;
        }
      }
      .icon_cart {
        width: 36px;
        height: 32px;
        background-image: url(../../assets/images/icon2.png);
        margin: 0 10px 0 0;
      }
      .icon_user {
        width: 36px;
        height: 36px;
        margin: 0 10px 0 0;
        border-radius: 50%;
        overflow: hidden;
        img {
          width: 100%;
        }
      }
    }
  }
}
</style>
